import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Auth0SessionService } from '../services/auth/identity/auth0-session.service';

@Injectable()
export class Auth0Guard implements CanActivate {
  private readonly sessions = inject(Auth0SessionService);
  private readonly router = inject(Router);
  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      if (await this.sessions.ensureSession()) return true;
    } catch { /* Login page provides an explicit retry when the local service is unavailable. */ }
    return this.router.createUrlTree(['/authentication/login'], { queryParams: { returnPath: state.url } });
  }
}
